import { useGetProductPage } from '@/api/websiteApi';
import { BackToTopButton } from '@/components/animate';
import { LoadingScreen } from '@/components/loading-screen';
import { SectionsComponents } from '@/page-sections/sections';
import { useEffect } from 'react';

type PropTypes = {
  uri: string;
};

const ProductPage = ({ uri }: PropTypes) => {
  const { data, loading } = useGetProductPage(uri);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (loading) {
    return <LoadingScreen color="primary" />;
  }

  return (
    <>
      <BackToTopButton />

      {data?.sections?.map((field) => {
        const componentName = field.fieldGroupName;

        if (!componentName || !SectionsComponents[componentName]) {
          return null;
        }

        const SectionComponent = SectionsComponents[componentName];
        return <SectionComponent key={componentName} section={field} />;
      })}
    </>
  );
};

export default ProductPage;
